import { supabase } from '../config/supabase';

export interface LaunchPeriodStatus {
  is_active: boolean;
  end_date: string | null;
  days_remaining: number;
}

export const getLaunchPeriodStatus = async (): Promise<LaunchPeriodStatus | null> => {
  try {
    const { data, error } = await supabase
      .from('launch_settings')
      .select('setting_value, end_date')
      .eq('setting_key', 'launch_mode_active')
      .single();

    if (error || !data) {
      return null;
    }

    const isActive = data.setting_value === true;
    const endDate = data.end_date;
    const now = new Date();
    const end = endDate ? new Date(endDate) : null;
    
    // Vérifier si la période est vraiment active (pas expirée)
    const isCurrentlyActive = isActive && (!end || end > now);
    
    const daysRemaining = end ? Math.ceil((end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)) : 0;

    return {
      is_active: isCurrentlyActive,
      end_date: endDate,
      days_remaining: Math.max(0, daysRemaining)
    };
  } catch (error) {
    console.error('Error fetching launch period status:', error);
    return null;
  }
};